import { render, staticRenderFns } from "./category-course.html?vue&type=template&id=362930d0&scoped=true&"
import script from "./category-course.js?vue&type=script&lang=js&"
export * from "./category-course.js?vue&type=script&lang=js&"
import style0 from "./category-course.scss?vue&type=style&index=0&id=362930d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362930d0",
  null
  
)

export default component.exports